import '../index.less';

import { Table, message } from 'antd';
import { useDispatch } from 'react-redux';

import { AppDispatch } from '../../../store/store';
import { displayDateAndTime } from '../../../utils/datetime.util';

import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { useEffect, useMemo, useState } from 'react';
import { getAccountSmsHistoryThunk } from '../../../services/collectionService/collectionThunk';
import { AccountEnquiryResponse } from '../../../features/collection/collectionSlice';

type SmsHistoryProps = {
  accountEnquiry: AccountEnquiryResponse;
};

const SmsHistory: React.FC<SmsHistoryProps> = (props) => {
  const { accountEnquiry } = props;
  const dispatch = useDispatch<AppDispatch>();

  const [smsHistoryData, setSmsHistoryData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const initialParams = useMemo(
    () => ({
      pagination: {
        current: 1,
        pageSize: 20,
      },
      sortOrder: 'desc',
      sortField: 'createdAt',
      search: {},
      filters: {},
    }),
    []
  );
  const [paginationState, setPaginationState] = useState(initialParams.pagination);

  const tablePagination = {
    total: smsHistoryData?.total ?? 0,
    showSizeChanger: true,
    showTotal: (total: number, range: number[]) => `${range[0]}-${range[1]} of ${total} items`,
    currentPage: paginationState.current,
    pageSize: paginationState.pageSize,
  };

  const columns: ColumnsType<any> = [
    {
      title: 'No.',
      key: 'id',
      render: (_, __, index: number) => index + 1,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Request Date',
      dataIndex: 'requestDate',
      key: 'requestDate',
      render: (text: string) => (text ? displayDateAndTime(text) : '-'),
    },
    {
      title: 'Requestor',
      dataIndex: 'requestor',
      key: 'requestor',
      // render: (_, record) => record?.requestor?.firstName ?? "-",
    },
    {
      title: 'Delivery Status',
      dataIndex: 'deliveryStatus',
      key: 'deliveryStatus',
    },
    {
      title: 'Sent Date & Time',
      dataIndex: 'sendDate',
      key: 'sendDate',
      render: (text: string) => (text ? displayDateAndTime(text) : '-'),
    },
    {
      title: 'SMS Message',
      dataIndex: 'smsMessage',
      key: 'smsMessage',
    },
  ];

  const fetchSmsHistory = async (params?: any) => {
    setLoading(true);
    await dispatch(getAccountSmsHistoryThunk({ ...params }))
      .unwrap()
      .then((res) => {
        setSmsHistoryData(res);
      })
      .catch((err) => {
        message.error('Failed to fetch SMS history');
        console.error('Failed to fetch SMS history', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTableChange = async (pagination: TablePaginationConfig) => {
    fetchSmsHistory({
      ...initialParams,
      pagination,
      accountDetailsId: accountEnquiry?.accountDetails?.id,
    });
    setPaginationState({
      current: pagination.current ?? 1,
      pageSize: pagination.pageSize ?? 10,
    });
  };

  useEffect(() => {
    if (accountEnquiry?.accountDetails?.id) {
      fetchSmsHistory({
        ...initialParams,
        accountDetailsId: accountEnquiry?.accountDetails?.id,
      });
    }
  }, [initialParams, accountEnquiry?.accountDetails?.id]);

  return (
    <div className="account-enquiry-container">
      <div className="account-enquiry-section-container">
        <div className="info-container">
          <Table
            columns={columns}
            dataSource={smsHistoryData?.data ?? []}
            pagination={tablePagination}
            loading={loading}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </div>
  );
};

export default SmsHistory;
